const IconFileError = ({ className }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none" stroke="#000" strokeWidth="3" viewBox="0 0 64 64"><path d="M34.48 54.28H11.06V18.61L23.02 5.75h25.65v33.67"/><path d="m23.04 5.75-.02 12.86H11.06M16.21 45.68h12.01M16.21 39.15h15.01M16.21 33.05h27.01M16.21 26.95h27.01"/><circle cx="42.92" cy="48.24" r="10.01" strokeLinecap="round"/><path d="m39.05 44.36 7.75 7.75M39.05 52.11l7.75-7.75"/></svg>
    )
  }
  
  export default IconFileError;